module.exports = __webpack_public_path__ + "static/media/PB_Y_10.b4ce941a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_10.png
// module id = 239
// module chunks = 0